<template>
  <div>
    <div class="list-page-header">
      <h3 class="title">{{ this.$t("communication_log.list_page_title") }}</h3>
    </div>
    <yv-index
      :path="path"
      :formSearch="formSearch"
      :enableExport="false"
      :columns="columns"
      :disabledHeaderActions="true"
      :sortable="sortable"
      :formatTableData="formatTableData"
      :tableActionsComponent="TableActions"
    >
    </yv-index>
    <common-modal
      width="60%"
      height="auto"
      name="CommunicationDetail"
      :hideFooter="true"
      :title="$t('communication_log.communication_detail')"
    >
      <template #modal-body>
        <CommunicationLogModal
          :communicationLogDetail="communicationLogDetail"
          modalName="CommunicationDetail"
        ></CommunicationLogModal>
      </template>
    </common-modal>
  </div>
</template>

<script>
import { YvIndex } from "@/components/Base";
import { service_paths } from "@/constants/Services";
import CommunicationLogModal from "./CommunicationLogModal.vue";
import TableActions from "./TableActions.vue";
import { convertDateFromServer } from "../../helpers/datetime-helper";
import { service_names } from "@/constants/Services";
import { getId, Message } from "@/helpers/utils";
import { mapGetters } from "vuex";
import { hasValidRole } from "@/helpers/role-helper";
import Role from "@/constants/Role";

export default {
  name: "communication-log",
  components: { YvIndex, CommunicationLogModal },
  data() {
    return {
      item: null,
      TableActions,
      path: service_paths.communication_logs,
      columns: {
        date_of_contact: "communication_log.col_date_contact",
        username: "communication_log.col_staff_contact",
        studentInfo: "communication_log.col_students",
        method: "communication_log.col_method",
        concerns: "communication_log.col_concerns",
        communication_detail: "communication_log.col_communication_detail",
        response_from_parent: "communication_log.col_responses_parent"
      },
      sortable: ["username"],
      communicationLogDetail: [],
      formSearch: [
        {
          label: "communication_log.filter_student_info",
          name: "student_id",
          value: "",
          fields: {
            text: "name",
            value: "id"
          },
          type: "autocomplete",
          options: [],
          refetchOptions: this.fetchStudent,
          searchKey: "search_key",
          width: 33
        },
        {
          label: "communication_log.filter_staff_contact",
          name: "staff_contact_id",
          value: "",
          fields: {
            text: "name",
            value: "id"
          },
          type: "autocomplete",
          options: [],
          refetchOptions: this.fetchStaff,
          searchKey: "search_key",
          width: 33
        },
        {
          label: "communication_log.filter_date_contact",
          name: "date_contact",
          value: [],
          type: "date-range",
          width: 33
        },
        {
          label: "communication_log.filter_method",
          name: "methods",
          value: [],
          type: "checkbox-multi-select",
          options: [
            {
              id: "Phone-call",
              name: this.$t("communication_log.phone_call")
            },
            {
              id: "Zoom-meeting",
              name: this.$t("communication_log.zoom_meeting")
            },
            {
              id: "Zalo",
              name: "Zalo"
            },
            {
              id: "Email",
              name: "Email"
            },
            {
              id: "Face-to-face",
              name: this.$t("communication_log.face_to_face")
            },
            {
              id: "Messenger",
              name: this.$t("communication_log.messenger")
            },
            {
              id: "Whatsapp",
              name: "Whatsapp"
            },
            {
              id: "Others",
              name: this.$t("communication_log.others")
            }
          ],
          trackBy: "id",
          displayField: "name",
          width: 33
        },
        {
          label: "communication_log.filter_concerns",
          name: "concerns",
          value: [],
          type: "checkbox-multi-select",
          options: [
            {
              id: "Academic",
              name: this.$t("communication_log.academic")
            },
            {
              id: "Behavior",
              name: this.$t("communication_log.behavior")
            },
            {
              id: "Attendance",
              name: this.$t("communication_log.attendance")
            },
            {
              id: "Homework",
              name: this.$t("communication_log.homework")
            },
            {
              id: "Academic-performance",
              name: this.$t("communication_log.academic_performance")
            },
            {
              id: "Extracurricular",
              name: this.$t("communication_log.extracurricular")
            },
            {
              id: "Students_account",
              name: this.$t("communication_log.students_account")
            },
            {
              id: "Parents Feedback",
              name: this.$t("communication_log.parents_feedback")
            },
            {
              id: "Others",
              name: this.$t("communication_log.others")
            }
          ],
          trackBy: "id",
          displayField: "name",
          width: 33
        }
      ]
    };
  },
  created() {
    this.fetchStaff();
    this.fetchStudent();
  },
  computed: {
    ...mapGetters("user", {
      userInfo: "info",
      userRole: "role"
    })
  },
  methods: {
    fetchStaff(param) {
      if (param) {
        param.fields = ["full_name", "staff_code"];
      }
      return this.$axios
        .get(
          `${service_names.user}/staffs/filter`,
          param,
          undefined,
          undefined,
          undefined,
          undefined,
          false
        )
        .then(res => {
          this.formSearch[1].options = res.data.data.map(item => ({
            id: getId(item),
            name: item.full_name + " - " + item.staff_code
          }));
        });
    },
    fetchStudent(param) {
      if (param) {
        param.fields = ["full_name", "student_code"];
      }
      let path = hasValidRole(this.userRole, [Role.Counselor, Role.Teacher])
        ? `${service_names.user}/students/management-teacher/${getId(
            this.userInfo
          )}`
        : `${service_names.user}/students/filter`;
      return this.$axios
        .get(path, param, undefined, undefined, undefined, undefined, false)
        .then(res => {
          this.formSearch[0].options = res.data.data.map(item => ({
            id: getId(item),
            name: item.full_name + " - " + item.student_code
          }));
        });
    },
    formatTableData(tableData) {
      return tableData.map(data => {
        data.username = `${data.created_by?.user_no_sql?.full_name} - ${data.created_by?.user_no_sql?.staff_code}`;
        data.studentInfo = `<p class="w-max inline-block">${data.student?.full_name} - ${data.student?.student_code}</p>`;
        data.date_of_contact = convertDateFromServer(
          data.date_of_contact,
          "date"
        );
        return data;
      });
    },
    viewCommunicationDetail(detail) {
      this.communicationLogDetail = detail;
      this.$modal.show("CommunicationDetail");
    }
  },
  provide() {
    return {
      viewCommunicationDetail: this.viewCommunicationDetail
    };
  }
};
</script>
